import { render, staticRenderFns } from "./editAlipay.vue?vue&type=template&id=5bb8e619&scoped=true&"
import script from "./editAlipay.vue?vue&type=script&lang=js&"
export * from "./editAlipay.vue?vue&type=script&lang=js&"
import style0 from "./editAlipay.vue?vue&type=style&index=0&id=5bb8e619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8e619",
  null
  
)

export default component.exports